import React, { useState } from 'react';
import styles from './servicedescri.module.css';
import Navbr from '../navbar/Navbar';
import Footer from '../footer/Footer';

// Process Icons
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import BarChartIcon from "@mui/icons-material/BarChart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


// New Benefit Icons (The ones that were missing)
import SpeedIcon from "@mui/icons-material/Speed"; 
import HubIcon from "@mui/icons-material/Hub"; 
import PsychologyIcon from "@mui/icons-material/Psychology"; 
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
const ServiceDescri = () => {
  const [activePhase, setActivePhase] = useState('AUDIT');

  const servicePhases = {
    AUDIT: {
      title: "AUDIT",
      IconComponent: SearchIcon, // Store the component itself
      shortDesc: "Comprehensive System Analysis",
      detailedDesc: "We conduct a thorough analysis of your existing systems and data infrastructure to identify optimization opportunities and integration points for our RAG framework.",
      features: [
        "Current system capability assessment",
        "Data source identification and evaluation",
        "Integration point mapping",
        "Performance baseline establishment",
        "Security and compliance review"
      ],
      color: "#00d4ff"
    },
    INTEGRATION: {
      title: "INTEGRATION",
      IconComponent: SettingsIcon,
      shortDesc: "Seamless Framework Implementation",
      detailedDesc: "Our innovative RAG framework blends data retrieval with AI, ensuring accurate, context-rich responses for <strong>real-time</strong>, dynamic interactions across your existing systems.",
      features: [
        "RAG framework deployment and configuration",
        "API and system integration",
        "Real-time data pipeline setup",
        "Legacy system compatibility assurance",
        "Multi-platform synchronization"
      ],
      color: "#00d4ff"
    },
    ANALYSIS: {
      title: "ANALYSIS",
      IconComponent: BarChartIcon,
      shortDesc: "Intelligent Data Processing",
      detailedDesc: "We implement advanced analytics and AI processing layers that examine retrieved data in context, generating meaningful insights and actionable intelligence.",
      features: [
        "AI-powered data interpretation",
        "Contextual response generation",
        "Pattern recognition and trend analysis",
        "Quality assurance validation",
        "Performance optimization monitoring"
      ],
      color: "#00d4ff"
    },
    RESULTS: {
      title: "RESULTS",
      IconComponent: CheckCircleIcon,
      shortDesc: "Actionable Insights Delivery",
      detailedDesc: "We transform processed data into actionable insights with our RAG framework, ensuring accurate, context-rich responses for <strong>real-time</strong>, dynamic decision-making.",
      features: [
        "Real-time insight delivery",
        "Customizable reporting dashboards",
        "Actionable recommendation generation",
        "Performance impact assessment",
        "Continuous improvement planning"
      ],
      color: "#00d4ff"
    }
  };

  return (
    <div className={styles.aiAgentPage}>
      <Navbr/>
      <div className={styles.techBg}></div>
      <div className={styles.floatingParticles}>
        {[...Array(8)].map((_, i) => <div key={i} className={styles.particle}></div>)}
      </div>

      <div className={styles.aiAgentHero}>
        <div className={styles.heroContent}>
          <div className={styles.heroTitleContainer}>
            <div className={styles.titleIcon}>ㅤ</div>
            <h1 className={styles.heroTitle}>
              <span className={styles.titleGradient}>Our Service Process</span>
              <span className={styles.titleSub}>That We Apply</span>
            </h1>
            <div className={styles.titleGlow}></div>
          </div>
          <p className={styles.heroDescription}>
            Innovative RAG framework blends data retrieval with AI, ensuring accurate, 
            context-rich responses for <strong>real-time</strong>, dynamic interactions.
          </p>

          <div className={styles.statsContainer}>
            <div className={styles.statItem}>
              <div className={styles.statNumber}>4</div>
              <div className={styles.statLabel}>Phases</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statNumber}>100%</div>
              <div className={styles.statLabel}>AI-Powered</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statNumber}>24/7</div>
              <div className={styles.statLabel}>Real-time</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statNumber}>∞</div>
              <div className={styles.statLabel}>Scalability</div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.darkSection}>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.darkSectionTitle}>Process Framework</h2>
            <p className={styles.darkSectionSubtitle}>
              A comprehensive journey from audit to results, powered by our innovative RAG technology
            </p>
          </div>

          <div className={styles.demoDashboardWrapper}>
            <div className={styles.darkServicesContainer}>
              <div className={styles.phaseNavigation}>
                {Object.keys(servicePhases).map((phase, index) => {
                  const Icon = servicePhases[phase].IconComponent;
                  return (
                    <button
                      key={phase}
                      className={`${styles.phaseNavItem} ${activePhase === phase ? styles.activeNavItem : ''}`}
                      onClick={() => setActivePhase(phase)}
                    >
                      <div className={styles.phaseNavIcon}>
                        <Icon className={styles.muiIcon} />
                      </div>
                      <span className={styles.phaseNavText}>{phase}</span>
                      <div className={styles.phaseNavNumber}>0{index + 1}</div>
                      <div className={styles.btnGlow}></div>
                    </button>
                  );
                })}
              </div>

              <div className={styles.phaseContent}>
                <div className={styles.phaseHeader}>
                  <div className={styles.phaseTitleContainer}>
                    <div className={styles.phaseTitleIcon}>
                      {/* Render active phase icon dynamically */}
                      {React.createElement(servicePhases[activePhase].IconComponent, { 
                        className: styles.muiIconLarge 
                      })}
                    </div>
                    <div>
                      <h3 className={styles.phaseTitle}>{servicePhases[activePhase].title}</h3>
                      <p className={styles.phaseSubtitle}>{servicePhases[activePhase].shortDesc}</p>
                    </div>
                  </div>
                </div>

                <div className={styles.detailedContent}>
                  <div className={styles.descriptionSection}>
                    <h4 className={styles.sectionTitle}>Process Description</h4>
                    <p 
                      className={styles.detailedDescription}
                      dangerouslySetInnerHTML={{ __html: servicePhases[activePhase].detailedDesc }}
                    />
                  </div>

                  <div className={styles.featuresSection}>
                    <h4 className={styles.sectionTitle}>Features</h4>
                    <div className={styles.featuresGrid}>
                      {servicePhases[activePhase].features.map((feature, index) => (
                        <div key={index} className={styles.featureCard}>
                          {/* <div className={styles.featureCheck}>✓</div> */}
                          <span className={styles.featureText}>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div className={styles.lightSection}>
  <div className={styles.sectionWrapper}>
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle2}>Why Choose Our Process</h2>
      <p className={styles.sectionSubtitle}>
        Discover the advantages of our comprehensive service framework
      </p>
    </div>

    <div className={styles.featuresGrid}>
      {/* Real-time Processing */}
      <div className={styles.featureCardLight}>
        <div className={styles.featureIconLight}>
          <SpeedIcon className={styles.muiIconLower} />
        </div>
        <h3 className={styles.featureTitle}>Real-time Processing</h3>
        <p className={styles.featureDesc}>
          Instant data analysis and response generation for dynamic interactions.
        </p>
      </div>

      {/* Seamless Integration */}
      <div className={styles.featureCardLight}>
        <div className={styles.featureIconLight}>
          <HubIcon className={styles.muiIconLower} />
        </div>
        <h3 className={styles.featureTitle}>Seamless Integration</h3>
        <p className={styles.featureDesc}>
          Compatible with existing systems and easy to implement across platforms.
        </p>
      </div>

      {/* Precision Analysis */}
      <div className={styles.featureCardLight}>
        <div className={styles.featureIconLight}>
          <PsychologyIcon className={styles.muiIconLower} />
        </div>
        <h3 className={styles.featureTitle}>Precision Analysis</h3>
        <p className={styles.featureDesc}>
          Accurate insights powered by advanced AI algorithms and RAG technology.
        </p>
      </div>

      {/* Actionable Results */}
      <div className={styles.featureCardLight}>
        <div className={styles.featureIconLight}>
          <TrendingUpIcon className={styles.muiIconLower} />
        </div>
        <h3 className={styles.featureTitle}>Actionable Results</h3>
        <p className={styles.featureDesc}>
          Clear, implementable recommendations that drive business growth.
        </p>
      </div>
    </div>
  </div>
</div>
      {/* Rest of the file stays the same... */}
      <Footer />
    </div>
  );
};

export default ServiceDescri;